import { useQuery } from "@tanstack/react-query";
import { getPurchases, RenewableEnergyPurchasesDTO, getAllowedValues, ALLOWED_VALUES, AllowedValuesDTO } from "api";
import { QUERY_KEYS } from "consts";

export const useGetCountries = () => useQuery<AllowedValuesDTO>([ALLOWED_VALUES.DICTIONARY], getAllowedValues);

export const useGetAllRenewableEnergyPurchases = () => useQuery<RenewableEnergyPurchasesDTO[]>([QUERY_KEYS.RENEWABLE_ENERGY_PURCHASES], getPurchases);
